var _this = this;
import * as tslib_1 from "tslib";
import { mutatorAction, orchestrator } from 'satcheljs';
import { default as showInImmersiveReader } from '../actions/showInImmersiveReader';
import { default as delay } from '../utils/delay';
import { getStore } from 'owa-immersive-reader-store';
import immersiveReaderProcessText from 'owa-immersive-reader-store/lib/services/immersiveReaderProcessText';
import { PerformanceDatapoint } from 'owa-analytics';
import { confirm } from 'owa-confirm-dialog';
import { default as populateItemId } from 'owa-service/lib/factory/itemId';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import strings from 'owa-strings/owa-mail-strings';
var VERSION1_1 = '1.1';
var VERSION2_0 = '2.0';
export default orchestrator(showInImmersiveReader, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var itemId, store, useV2Api, dp, startTime, success, readerModel, error, response, endTime, launchToPostMessageSentDurationInMs, apiResponse, maxRetries, retryCount, ex_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                itemId = actionMessage.itemId;
                store = getStore();
                // Don't proceed if itemId is null, or we are already in the middle of a service call, or
                // the immersive reader is already showing.
                if (!itemId ||
                    store.isLoading ||
                    store.immersiveReaderFrameState !== 0 /* Closed */) {
                    return [2 /*return*/];
                }
                useV2Api = isMailFeatureEnabled('rp-immersiveReaderV2Endpoint');
                dp = new PerformanceDatapoint('ShowInImmersiveReader');
                dp.addCustomData({ sessionId: store.sessionId });
                dp.addActionSource(actionMessage.actionSource);
                toggleLoadingState(true);
                // Show iframe and begin loading immersive reader app
                toggleShowingState(true);
                startTime = new Date().getUTCMilliseconds();
                success = true;
                readerModel = null;
                error = null;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, 8, 9]);
                return [4 /*yield*/, immersiveReaderProcessText(populateItemId({ Id: itemId.Id }), store.sessionId, useV2Api ? VERSION2_0 : VERSION1_1, itemId.mailboxInfo && itemId.mailboxInfo.requestOptions)];
            case 2:
                response = _a.sent();
                dp.addCheckmark('ImmersiveReaderProcessText_Done');
                // Parse ReaderModel from service call response
                if (!response || !response.ReaderModelJson) {
                    success = false;
                    error = 'Response from service call was null or did not contain a ReaderModelJson';
                }
                else {
                    readerModel = JSON.parse(response.ReaderModelJson);
                }
                if (!success) return [3 /*break*/, 6];
                endTime = new Date().getUTCMilliseconds();
                launchToPostMessageSentDurationInMs = (endTime - startTime).toString();
                apiResponse = null;
                if (useV2Api) {
                    readerModel.launchToPostMessageSentDurationInMs = launchToPostMessageSentDurationInMs;
                    apiResponse = {
                        messageType: 'LinguisticModel',
                        messageValue: readerModel,
                    };
                }
                else {
                    apiResponse = {
                        messageType: 'ReaderModel2',
                        messageValue: {
                            launchToPostMessageSentDurationInMs: launchToPostMessageSentDurationInMs,
                            readerModel: readerModel,
                        },
                    };
                }
                setApiResponse(apiResponse);
                maxRetries = 120;
                retryCount = 0;
                _a.label = 3;
            case 3:
                if (!(retryCount < maxRetries &&
                    getStore().immersiveReaderFrameState === 1 /* Showing */)) return [3 /*break*/, 5];
                return [4 /*yield*/, delay(500)];
            case 4:
                _a.sent();
                retryCount++;
                return [3 /*break*/, 3];
            case 5:
                if (getStore().immersiveReaderFrameState === 1 /* Showing */) {
                    success = false;
                    error = 'Frame never got to Ready state';
                }
                _a.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                ex_1 = _a.sent();
                success = false;
                dp.addCheckmark('CaughtException');
                error = ex_1.toString();
                return [3 /*break*/, 9];
            case 8:
                toggleLoadingState(false);
                return [7 /*endfinally*/];
            case 9:
                if (success) {
                    dp.end();
                }
                else {
                    // Hide immersive reader if something went wrong
                    toggleShowingState(false);
                    dp.endWithError("ServerError" /* ServerError */, new Error(error));
                    // Show error dialog
                    confirm(strings.immersiveReaderErrorTitle, strings.immersiveReaderErrorText, false, {
                        hideCancelButton: true,
                    });
                }
                return [2 /*return*/];
        }
    });
}); });
var toggleLoadingState = mutatorAction('toggleImmersiveReaderLoadingState', function (isLoading) {
    getStore().isLoading = isLoading;
});
var toggleShowingState = mutatorAction('toggleImmersiveReaderShowingState', function (isShowing) {
    getStore().immersiveReaderFrameState = isShowing
        ? 1 /* Showing */
        : 0 /* Closed */;
});
var setApiResponse = mutatorAction('setImmersiveReaderApiResponse', function (apiResponse) {
    getStore().apiResponse = apiResponse;
});
//# sourceMappingURL=showInImmersiveReaderOrchestrator.js.map